export enum ApprovalPersonnel {
  Developer = 'developer',
  Support = 'support',
}
